module.exports = __webpack_public_path__ + "img/processing-10.224faa01.gif";